<div class="dialog">
    <div class="dialog-header">
        <h2 *ngIf="!model.id">{{ 'offers.dialog.reward-move.heading' | translate }}</h2>
        <h2 *ngIf="model.id">{{ 'offers.dialog.reward-move.heading.edit' | translate }}</h2>
        <a class="dialog-close" (click)="onClose()">&times;</a>
    </div>

    <form #form="ngForm" (ngSubmit)="onSubmit(form)">
        <input name="strategy_phase_id" type="hidden" [(ngModel)]="model.strategy_phase_id" required />

        <div class="dialog-body scope-phases" *ngIf="!selectedPhase">
            <app-loading *ngIf="loading" height="238px"></app-loading>

            <div *ngIf="!loading">
                <div class="card scope-phase" *ngFor="let phase of phases" (click)="onSelectPhase(phase)">
                    <div class="card-body">
                        <div class="flex">
                            <div class="scope-phase-meta">
                                <div class="scope-phase-percents">
                                    {{ phase.playground.min }}% - {{ phase.playground.max }}%
                                    <small *ngIf="phase.is_default">Default</small>
                                </div>
                                <div class="scope-phase-dates">
                                    {{ phase.start_date | localizedDate }} - {{ (phase.end_date | localizedDate) || 'to the end…' }}
                                </div>
                            </div>
                            <div class="scope-phase-button">
                                <button class="button">
                                    {{ 'shared.button.select' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="dialog-body scope-form" *ngIf="selectedPhase">
            <div class="row">
                <div class="small-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="form-row form-required">
                                <label>{{ 'shared.label.date-from' | translate }}</label>
                                <app-form-datepicker
                                    [disabled]="isFieldDisabled('start_date')"
                                    name="start_date"
                                    [required]="true"
                                    [resetable]="false"
                                    [min]="getStartDateMin()"
                                    [max]="getStartDateMax()"
                                    [(ngModel)]="model.start_date">
                                </app-form-datepicker>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="small-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="form-row">
                                <label>{{ 'shared.label.date-to' | translate }}</label>
                                <app-form-datepicker
                                    [disabled]="isFieldDisabled('end_date')"
                                    name="end_date"
                                    [resetable]="false"
                                    [min]="getEndDateMin()"
                                    [max]="getEndDateMax()"
                                    [(ngModel)]="model.end_date">
                                </app-form-datepicker>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="small-12">
                    <div class="card" style="margin: 0">
                        <div class="card-body">
                            <div class="form-row form-required">
                                <label>{{ 'shared.label.rate' | translate }}</label>
                                <div class="form-range">
                                    <div class="form-control">
                                        <input
                                            [disabled]="isFieldDisabled('cashback_rate')"
                                            type="range"
                                            name="model.cashback_rate"
                                            [minValue]="defaultPhase?.cashback_rate"
                                            [maxValue]="selectedPhase.playground.max"
                                            [min]="defaultPhase?.cashback_rate"
                                            [max]="selectedPhase.playground.max"
                                            step=".1"
                                            [(ngModel)]="model.cashback_rate">

                                        <div class="form-range-meta">
                                            <div class="form-range-min">
                                                {{ defaultPhase?.cashback_rate | localizedNumber }}%
                                            </div>
                                            <div class="form-range-max">
                                                {{ selectedPhase.playground.max | localizedNumber }}%
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-value">
                                        <div>
                                            <input
                                                [disabled]="isFieldDisabled('cashback_rate')"
                                                type="number"
                                                name="model.cashback_rate"
                                                [minValue]="0"
                                                [maxValue]="100"
                                                [(ngModel)]="model.cashback_rate">
                                            <span>%</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="small-12" style="visibility: hidden">
                    <div class="card">
                        <div class="card-body">
                            <div class="form-row form-required">
                                <app-form-multi-input
                                    [disabled]="isFieldDisabled('terms')"
                                    type="textarea"
                                    rows="5"
                                    label="shared.label.terms"
                                    name="legal_terms"
                                    [(ngModel)]="model.legal_terms"
                                    [translation]="model.translation?.legal_terms">
                                </app-form-multi-input>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>

        <div class="dialog-footer">
            <div class="buttons">
                <a class="button button-basic-primary" (click)="onClose()">
                    {{ 'shared.button.close' | translate }}
                </a>
                <button type="submit" class="button button-primary" [disabled]="form.form.invalid">
                    {{ 'shared.button.save' | translate }}
                </button>
            </div>
        </div>
    </form>
</div>

